import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const dashboardService = {
  async getDashboardStatistics() {
    try {
      const response = await api_fetch.get(
        '/v1/statistics',
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
      throw error;
    }
  },

  async getPackageDetailsStatistics() {
    try {
      const response = await api_fetch.get(
        '/v1/package-details-statistics',
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching package details statistics:', error);
      throw error;
    }
  },

  async getZoeShipmentTrackingStatistics() {
    try {
      const response = await api_fetch.get(
        '/v1/zoe-shipment-tracking-statistics',
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching Zoe shipment tracking statistics:', error);
      throw error;
    }
  },

  async getPackageDetailsMonthlyStatistics(year = null) {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);

      const queryString = params.toString();
      const url = `/v1/package-details-monthly-statistics${queryString ? `?${queryString}` : ''}`;

      const response = await api_fetch.get(
        url,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error(
        'Error fetching package details monthly statistics:',
        error
      );
      throw error;
    }
  },

  async getZoeShipmentTrackingMonthlyStatistics(year = null) {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);

      const queryString = params.toString();
      const url = `/v1/zoe-shipment-tracking-monthly-statistics${queryString ? `?${queryString}` : ''}`;

      const response = await api_fetch.get(
        url,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error(
        'Error fetching Zoe shipment tracking monthly statistics:',
        error
      );
      throw error;
    }
  },

  async getPackageDetailsDailyStatistics(year = null, month = null) {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);

      const queryString = params.toString();
      const url = `/v1/package-details-daily-statistics${queryString ? `?${queryString}` : ''}`;

      const response = await api_fetch.get(
        url,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching package details daily statistics:', error);
      throw error;
    }
  },

  async getZoeShipmentTrackingDailyStatistics(year = null, month = null) {
    try {
      const params = new URLSearchParams();
      if (year) params.append('year', year);
      if (month) params.append('month', month);

      const queryString = params.toString();
      const url = `/v1/zoe-shipment-tracking-daily-statistics${queryString ? `?${queryString}` : ''}`;

      const response = await api_fetch.get(
        url,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error(
        'Error fetching Zoe shipment tracking daily statistics:',
        error
      );
      throw error;
    }
  },

  async getCurrentMonthDailyStatistics() {
    try {
      const response = await api_fetch.get(
        '/v1/current-month-daily-statistics',
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      );

      return response.json();
    } catch (error) {
      console.error('Error fetching current month daily statistics:', error);
      throw error;
    }
  }
};

export default dashboardService;
